import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Class: EventPhase
var EventPhase = /** @class */ (function (_super) {
    __extends(EventPhase, _super);
    function EventPhase() {
        return _super.call(this) || this;
    }
    EventPhase.classInitializer = null;
    EventPhase.classSymbols = null;
    EventPhase.instanceSymbols = null;
    // JS -> AS Bindings
    EventPhase.CAPTURING_PHASE = 1;
    EventPhase.AT_TARGET = 2;
    EventPhase.BUBBLING_PHASE = 3;
    return EventPhase;
}(ASObject));
export { EventPhase };
